<template>
<h4 :class="`odr-title-minor odr-title-minor_color-${color}`">
    <slot></slot>
</h4>
</template>
<script>
import { coloringMixin } from '../mixins/coloring'
import '../styles/title-minor.scss'

export default {
    mixins: [coloringMixin],
}
</script>
